// extracted by mini-css-extract-plugin
export default {"gridContainer":"ReportsTab_gridContainer__VEm5P"};